import { getConfigValue } from '@jutro/config';
import { subscribe, JUTRO_TOPICS, loadGtag, DefaultDictionaryProvider,
    DefaultWhitelistProvider } from '@jutro/events';
import {
    useAuthentication,
    withAuthenticationProvider,
} from '@xengage/gw-digital-auth-react';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import Analytics from '../../../common/capabilities/cpmi-capability-analytics/services/Analytics'
import appConfig from 'app-config';
import {useEffect} from 'react'

export default function usecpmiAnalytics() {
    const auth = useAuthentication();
    const {authHeader} = useAuthentication();
    const ga = loadGtag(getConfigValue('GA_TRACKING_ID'));

    function trackPageView(title,page){
        const userID = auth.userInfo.email;
        if (userID !== null ) {

        return Analytics.trackActivity([{
            applicationName: 'CE',
            activityType: 'pageview',
            userID: userID,
            title: title,
            page: page
        }],authHeader)
    }
    }

    function trackEvent(title,page){
        const { trackingConfig = {} } = appConfig;
    const whitelist = DefaultWhitelistProvider.create(trackingConfig.whitelistConfig);
    const translate = DefaultDictionaryProvider.create(
        trackingConfig.dictionaryConfig
    );
    ga('send', {
                hitType: 'event',
                eventCategory: title,
                // eventAction: topic,
                eventLabel: page,
            });
        // subscribe(
        // ['JUTRO_TOPICS.BUTTON_CLICKED', 'JUTRO_TOPICS.VALUE_CHANGED', 'JUTRO_TOPICS.FIELD_BLUR','JUTRO_TOPICS.LINK_CLICKED'],
        // (event, topic) => {
        //     const transformedEvent = translate(whitelist(event));
        //     console.log("topic",topic);
        //     console.log("transformed event ",JSON.stringify(transformedEvent));
        //     ga('send', {
        //         hitType: 'event',
        //         eventCategory: JSON.stringify(transformedEvent.label),
        //         eventAction: topic,
        //         eventLabel: JSON.stringify(transformedEvent),
        //     });
        // });
        const userID = auth.userInfo.email;
        if (userID !== null ) {

        return Analytics.trackActivity([{
            applicationName: 'CE',
            activityType: 'event',
            userID: userID,
            title: title,
            page: page
        }],authHeader)
    }
    }

    return [trackPageView,trackEvent]
}